<div fxLayout="column" class="dialog" fxFlex="grow">
  <div>
    <header>
      <div mat-dialog-title>
        <div fxLayout="row" fxLayoutAlign="center center ">
          <h1>{{ 'easy-trade.origin.modal.title' | translate }}</h1>
          <button mat-icon-button style="position: absolute; top: 0; right: 0" (click)="dialogRef.close()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <mat-divider></mat-divider>
      </div>
    </header>

    <div>
      <span class="spanUploadFile" *ngIf="UploadFilesSpan">{{ 'easy-trade.origin.modal.span-uploadfile' | translate }}</span>
      <span class="spanUploadFile" *ngIf="amountOfCertificates">{{ 'easy-trade.origin.modal.amount-certificates' | translate }} </span>

      <mat-card
        class="mat-elevation-z8 card"
        (dragover)="onDragOverEvent($event)"
        (dragleave)="isDragOver = false"
        (mouseleave)="isDragOver = false"
        (drop)="onFileDrop($event)"
        cardBackground
        lightBg="#fff"
        [lightColor]="'#051D38'"
        [darkBg]="'#205679'"
        darkColor="#fff"
        [ngClass]="{ 'error-border': fileErrorMsg }"
      >
        <mat-card-content fxLayout="column" fxLayoutAlign="space-between space-between">
          <div class="card__content--upload upload" fxLayout="column" fxLayoutAlign="center center" (click)="fileUpload.click()">
            <mat-icon
              class="icon"
              cla
              [class]="isDragOver || _change?.file ? 'upload__icon-display' : 'upload__icon-display upload__icon-display material-icons-outlined'"
              [ngClass]="{ 'error-icon': fileErrorMsg }"
            >
              cloud_upload</mat-icon
            >
            <div>
              <p class="upload__message" *ngIf="!fileErrorMsg">{{ 'easy-trade.new-trade.stepper.details-requirements.upload-document' | translate }}</p>
              <span class="upload__file-info file-info" fxLayout="row" fxLayoutAlign="space-between center" *ngFor="let file of UploadFiles">
                <p class="file-info__file-name" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                  <mat-icon class="material-icons-outlined file-name--file-icon">text_snippet</mat-icon>
                  <span>{{ file.certificate.name }}</span>
                </p>
                <button type="file-info__button" mat-icon-button (click)="removeFile($event, file)">
                  <mat-icon color="warn">delete</mat-icon>
                </button>
              </span>
            </div>
          </div>
          <span class="error-message" *ngIf="fileErrorMsg" [innerHtml]="'easy-trade.new-trade.stepper.details-requirements.upload-file-type-error' | translate"></span>
          <input style="display: none" (click)="$event.target.value = null" type="file" #fileUpload (change)="fileLoaded($event.target.files)" />
        </mat-card-content>
      </mat-card>
    </div>
    <mat-divider class="divider"></mat-divider>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
      <div class="container-co">
        <span class="title_row">Total: {{ certificados.length }}</span>
      </div>
      <div class="button-group" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
        <button mat-button (click)="dialogRef.close(false)">
          {{ 'easy-trade.origin.modal.button.cancel' | translate }}
        </button>
        <button mat-button class="btn-color" (click)="save()" [disabled]="!UploadFiles.length || loading || isFinished" [class.spinner]="loading">
          {{ 'easy-trade.origin.modal.button.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
